import React, { FC, PropsWithChildren, ReactElement } from 'react'
import { Box, Button, DialogActions, DialogContent } from '@mui/material'
import { useTranslate } from 'src/i18n/useMessageSource'
import { AlertModalDialog } from 'src/ui-shared/base/model-dialog/AlertModalDialog'

interface Props extends PropsWithChildren {
  alert: 'error' | 'warning'
  openDialog: boolean
  onCancel: () => void
  onConfirm?: () => void
  confirmationKey?: string
  cancellationKey?: string
}

export const AlertActionModalDialog: FC<Props> = ({
  children,
  alert,
  openDialog,
  onCancel,
  onConfirm,
  confirmationKey,
  cancellationKey,
}): ReactElement => {
  const translate = useTranslate()

  return (
    <AlertModalDialog alert={alert} maxWidth="sm" open={openDialog} onClose={onCancel} withCloseIcon>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button variant="text" color="primary" onClick={onCancel}>
            {cancellationKey ? translate(cancellationKey) : translate('button.close')}
          </Button>

          {onConfirm && (
            <Button autoFocus onClick={onConfirm} color="primary" variant="text">
              {confirmationKey ? translate(confirmationKey) : translate('button.confirm')}
            </Button>
          )}
        </Box>
      </DialogActions>
    </AlertModalDialog>
  )
}
